import styled from "styled-components";

export const StyledCampaignSummary = styled.div`
  margin: 30px 0;
`;
